import React from 'react';
import { GenericFields } from '../../../api/services/next';
import DropDown from '../dropdown';

const GenericFieldNamesDropDown = ({ ...rest }) => {
    return (
        <DropDown
            textField='FieldName'
            valueField='Id'
            api={GenericFields.GetGenericFields}
            {...rest}
        />
    );
};

export default GenericFieldNamesDropDown;
